import { PERMISSIONS, Security } from ".";
export class DefaultSecurity extends Security {
    getAccessLevel() {
        return PERMISSIONS.ALL;
    }
}
//# sourceMappingURL=default.js.map